import filteredAndSortedBens from 'pages/simulation/products/hooks/filteredAndSortedBens'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { Bem } from 'types/bem'
import { SortBemsType } from 'types/sortFunctions'
import { create } from 'zustand'
import { combine, createJSONStorage, persist } from 'zustand/middleware'

type BemFormState = {
  vl_bem_inicial: number
  vl_bem_final: number
  vl_parcela_inicial: number
  vl_parcela_final: number
}

interface BemInfo {
  bem: Bem
  bens: Bem[]
  filteredAndSortedBems: Bem[]
  defaultFilterValues: BemFormState
  currentFilterValues: BemFormState
  sortOptions: keyof SortBemsType
}

const DEFAULT_FILTER_VALUES: BemFormState = {
  vl_bem_inicial: 0,
  vl_bem_final: 0,
  vl_parcela_inicial: 0,
  vl_parcela_final: 0
}

const DEFAULT_BEM_INFO: BemInfo = {
  bem: {} as Bem,
  bens: [],
  sortOptions: 'minValue',
  filteredAndSortedBems: [],
  currentFilterValues: DEFAULT_FILTER_VALUES,
  defaultFilterValues: DEFAULT_FILTER_VALUES
}

const useBemStore = create(
  persist(
    combine(DEFAULT_BEM_INFO, (set) => ({
      setBem: (bem: Bem) => set({ bem }),
      setBens: (bens: Bem[]) => set({ bens }),
      setDefaultFilterValues: (defaultFilterValues: BemFormState) => set({ defaultFilterValues }),
      setCurrentFilterValues: (currentFilterValues: BemFormState) => set({ currentFilterValues }),
      setFilteredAndSortedBems: (
        bens: Bem[],
        currentFilterValues: BemFormState,
        sortOptions: keyof SortBemsType
      ) => {
        const filteredAndSortedBems = filteredAndSortedBens(bens, currentFilterValues, sortOptions)
        set({ filteredAndSortedBems })
      },

      setSortOptions: (sortOptions: keyof SortBemsType) => set({ sortOptions }),

      resetBem: () => {
        localStorage.removeItem('bem-storage')
        set(DEFAULT_BEM_INFO)
      }
    })),
    {
      name: 'bem-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Bem Store', useBemStore)
}

export default useBemStore
